import { GenericDialog } from "@/components/dialogs";
import { useState } from "react";

type CommentDialogProps = {
  caption: string;
  comment?: string;
  required?: boolean;
  onAccept: (comment: string) => void;
};

export const CommentsDialog = (props: CommentDialogProps) => {
  const [comment, setComment] = useState<string>(props.comment ?? "");

  return (
    <GenericDialog
      caption={props.caption}
      buttons="OKCancel"
      allowAccept={props.required !== true || comment.length > 0}
      onAccept={() => props.onAccept(comment)}
    >
      <textarea
        className="form-control"
        rows={6}
        cols={60}
        value={comment}
        onChange={(e) => setComment(e.currentTarget.value)}
        autoFocus
      />
    </GenericDialog>
  );
};
